// 设备管理
const gasControllerJurisdiction = [
  { id: '046002001', label: '添加', children: [] },
  { id: '046002003', label: '修改', children: [] },
  { id: '046002002', label: '删除', children: [] },
]

// 燃气表管理
const gasAmmeterJurisdiction = [
  { id: '046002005', label: '添加', children: [] },
  { id: '046002006', label: '删除', children: [] },
  { id: '046002007', label: '修改', children: [] },
  { id: '046002008', label: '查看历史燃气量', children: [] },
  { id: '046002009', label: '导入燃气表', children: [] },
  { id: '046002010', label: '导出燃气表', children: [] },
]

// 燃气量监测
const gasMonitoringJurisdiction = [{ id: '046012001', label: '导出', children: [] }]

// 收费配置
const gasConfigJurisdiction = [{ id: '046003001', label: '修改', children: [] }]

// 场景配置
const gasSceneConfigJurisdiction = [
  { id: '046004001', label: '添加', children: [] },
  { id: '046004002', label: '删除', children: [] },
]

// 结算配置
const gasConfigSettleJurisdiction = [{ id: '046004006', label: '保存', children: [] }]

// 按燃气表统计
const gasQuantityJurisdiction = [{ id: '046005001', label: '导出', children: [] }]
// 设备状态日志
const gasControllerDeviceStatusLogJurisdiction = [{ id: '046010001', label: '导出', children: [] }]

// 智慧燃气
const gasServiceJurisdictionChildren = [
  {
    id: '046001000',
    label: '概览',
    routerName: 'gas-over-view',
    children: [],
  },
  {
    id: '046002000',
    label: '集中器管理',
    routerName: 'gas-controller-management',
    children: gasControllerJurisdiction,
  },
  {
    id: '046002004',
    label: '燃气表管理',
    routerName: 'gas-ammeter-management',
    children: gasAmmeterJurisdiction,
  },
  {
    id: '046003000',
    label: '收费配置',
    routerName: 'gas-config-center',
    children: gasConfigJurisdiction,
  },
  {
    id: '046004000',
    label: '场景配置',
    routerName: 'gas-device-scene-config',
    children: gasSceneConfigJurisdiction,
  },
  {
    id: '046004005',
    label: '结算配置',
    routerName: 'gas-config-settle',
    children: gasConfigSettleJurisdiction,
  },
  {
    id: '046005000',
    label: '按燃气表统计',
    routerName: 'gas-quantity',
    children: gasQuantityJurisdiction,
  },
  {
    id: '046006000',
    label: '按住户统计',
    routerName: 'gas-quantity-public',
    children: [],
  },
  {
    id: '046012000',
    label: '燃气量检测',
    routerName: 'gas-monitoring',
    children: gasMonitoringJurisdiction,
  },
  {
    id: '046007000',
    label: '余额管理',
    routerName: 'gas-rent-money',
    children: [],
  },
  {
    id: '046008000',
    label: '充值记录',
    routerName: 'gas-pay-record',
    children: [],
  },
  {
    id: '046009000',
    label: '结算记录',
    routerName: 'gas-settlement-record',
    children: [],
  },
  {
    id: '046010000',
    label: '设备状态日志',
    routerName: 'gas-controller-device-status-log',
    children: gasControllerDeviceStatusLogJurisdiction,
  },
  {
    id: '046011000',
    label: '操作日志',
    routerName: 'gas-log',
    children: [],
  },
]

const gasServiceJurisdiction = {
  id: '046',
  label: '智慧燃气',
  children: gasServiceJurisdictionChildren,
}

export { gasServiceJurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/gasServiceJurisdiction.js